import { gql } from 'apollo-angular';

export const GetDataByTypeDocument = gql`
  query getDataByType($funnelId: Int!, $type: String!) {
    getDataByType(funnelId: $funnelId, type: $type) {
      data
    }
  }
`;
